<section class="photo-gallery-section" *ngIf="isOpen">
  <div class="gallery-background">
    <img [src]="getImageUrl('images/sections/gallery-section/gallery-background-cut2.webp')" alt="Fondo de galería" class="background-image">
    <div class="color-overlay"></div>
  </div>
  
  <!-- Galería de Habitaciones y Suites -->
  <div class="rooms-gallery">
    <!-- Contenedor de imágenes con efecto fluido -->
    <div class="gallery-images-container">
      <!-- Descripción flotante en el espacio de las imágenes colapsadas -->
      <div class="gallery-description-overlay" 
           [style.left]="getDescriptionPosition()"
           [style.transform]="getDescriptionTransform()">
        <img [src]="activeCategory.icon" alt="Ícono" class="description-icon">
        <h3>{{ activeCategory.title }}</h3>
      </div>
      
      <div 
        *ngFor="let category of categories" 
        class="gallery-item"
        [class.expanded]="category.isActive"
        (click)="selectCategory(category.id)"
      >
        <img [src]="category.mainImage" [alt]="category.title" class="gallery-image">
        
        <!-- Capa negra para imágenes no activas -->
        <div class="gallery-overlay" *ngIf="!category.isActive"></div>
      </div>
    </div>
  </div>
</section>
